
import Highlight from '../../../components/base/Highlight';

export default function DmmFxSafety() {
  const safetyFeatures = [
    {
      icon: 'ri-government-line',
      title: '金融庁登録済み',
      description:
        '関東財務局長（金商）第1629号として正式に登録されており、金融庁の厳格な監督下で運営されています。',
      color: 'from-teal-500 to-emerald-600',
    },
    {
      icon: 'ri-shield-check-line',
      title: '全額信託保全',
      description:
        '顧客の資産は信託銀行で完全に分別管理。万が一DMM.com証券が破綻しても、預けた資金は全額保護されます。',
      color: 'from-emerald-500 to-teal-600',
    },
    {
      icon: 'ri-building-line',
      title: 'DMMグループの信頼性',
      description:
        '大手企業グループDMMの一員として、豊富な資本力と安定した経営基盤を持っています。',
      color: 'from-teal-500 to-emerald-600',
    },
    {
      icon: 'ri-customer-service-2-line',
      title: '24時間サポート体制',
      description:
        'HDI格付け三つ星を獲得した業界最高水準のサポート。平日24時間、電話・メール・LINEで対応しています。',
      color: 'from-emerald-500 to-teal-600',
    },
    {
      icon: 'ri-lock-line',
      title: '高度なセキュリティ',
      description:
        'SSL暗号化通信、二段階認証など、最新のセキュリティ技術で個人情報と取引を保護しています。',
      color: 'from-teal-500 to-emerald-600',
    },
    {
      icon: 'ri-user-line',
      title: '口座数90万以上',
      description:
        '多くのトレーダーに選ばれている実績があり、信頼性の高さを証明しています。',
      color: 'from-emerald-500 to-teal-600',
    },
  ];

  return (
    <section className="py-16 bg-white">
      <div className="max-w-6xl mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            <Highlight variant="underline" color="red">DMM FXの安全性が高い理由</Highlight>
          </h2>
          <p className="text-lg text-gray-600">
            6つの安全対策で、あなたの資産と取引を守ります
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {safetyFeatures.map((feature, index) => (
            <div
              key={index}
              className="bg-white rounded-xl p-8 shadow-md hover:shadow-xl transition-all border border-gray-100"
            >
              <div
                className={`w-16 h-16 bg-gradient-to-br ${feature.color} rounded-xl flex items-center justify-center mb-6`}
              >
                <i className={`${feature.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                {index === 0 || index === 1 ? (
                  <Highlight variant="marker" color="red">{feature.title}</Highlight>
                ) : (
                  feature.title
                )}
              </h3>
              <p className="text-gray-600 leading-relaxed text-sm">
                {index === 3 ? (
                  <>
                    <Highlight variant="bold" color="red">HDI格付け三つ星</Highlight>を獲得した業界最高水準のサポート。平日<Highlight variant="bold" color="red">24時間</Highlight>、電話・メール・LINEで対応しています。
                  </>
                ) : index === 5 ? (
                  <>
                    多くのトレーダーに選ばれている実績があり、<Highlight variant="bold" color="red">口座数90万以上</Highlight>の信頼性の高さを証明しています。
                  </>
                ) : (
                  feature.description
                )}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-12 bg-gradient-to-br from-teal-50 to-emerald-50 rounded-2xl p-8 border-l-4 border-teal-500">
          <div className="flex items-start gap-4">
            <i className="ri-shield-star-line text-4xl text-teal-600 flex-shrink-0"></i>
            <div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                なぜDMM FXは安全なのか？
              </h3>
              <p className="text-gray-700 leading-relaxed mb-4">
                DMM FXは金融商品取引業者として<Highlight variant="marker" color="red">金融庁に正式登録</Highlight>されており、厳格な法令遵守が求められています。また、顧客の資産は<Highlight variant="marker" color="red">全額信託保全</Highlight>により完全に保護されているため、万が一の事態でも安心です。
              </p>
              <p className="text-gray-700 leading-relaxed">
                さらに、DMMグループという大手企業の一員であることも、財務的な安定性と信頼性を裏付けています。<Highlight variant="bold" color="red">24時間対応</Highlight>のサポート体制も整っており、初心者でも安心して取引を始められる環境が整っています。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
